import React from 'react';
import '../../scss/LoadingIndicator.css'; // Import CSS for styling

const LoadingIndicator = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingIndicator;
